import { StyledCol, StyledIcon, StyledRow, StyledTitle } from '@/shared/styles';
import { backArrow } from '@/assets/images/icons';
import { CheckerStatus } from '../../AccessibilityChecker.consts';
import { useTranslation } from 'react-i18next';
import { PinkGradientLink } from '@/shared/components/Link/PinkGradientLink';
import { FixIssuesBanner } from './FixIssuesBanner';
import { isMobileOnly } from 'react-device-detect';
import { DesktopStoreCards } from './ScoreCards/DesktopStoreCards';
import { MobileStoreCards } from './ScoreCards/MobileScoreCards';
import { useAccessibilityCheckerStore } from '@/stores/AccessibilityCheckerStore/AccessibilityCheckerStore';

export const AccessibilityScore: React.FC = () => {
  const { t } = useTranslation();
  const { setStatus } = useAccessibilityCheckerStore();

  return (
    <StyledCol $gap={20}>
      <StyledRow>
        <PinkGradientLink
          onClick={() => {
            setStatus(CheckerStatus.PRESCAN);
          }}
          text={t('free_tools.accessibility_checker.back_to_home')}
          inRow
          isButton={true}
        >
          <StyledIcon src={backArrow} aria-hidden="true" />
        </PinkGradientLink>
      </StyledRow>
      <StyledTitle className="u1st-sr-only">
        {t('free_tools.accessibility_checker.a11y_results.title')}
      </StyledTitle>
      <StyledTitle className="u1st-sr-only" level={2}>
        {t('free_tools.accessibility_checker.a11y_results.overview')}
      </StyledTitle>
      {isMobileOnly ? <MobileStoreCards /> : <DesktopStoreCards />}
      <FixIssuesBanner />
    </StyledCol>
  );
};
